export const chapter2 = [

    //page 9
    'As they got closer, they could see the town gates,',
    'They didn‘t realise yet inside would change their fates,',
    'One step at a time each heavier than the last trod,',
    'They had made it to a wooden gate tall and broad,',
    '“Open up!” Eanom hollered with the last air in his lungs,',
    'A man appeared who swore in the common tongue,',
    '“Yeah, what do you want?” He looked tired and hungover,',
    '“Open the damn door before we die of exposure!”',
    'Sigg‘s command snapped the man into line,',
    'The gate creaked and revealed what was behind,',
    'A number of simple houses, shops and stalls,',
    'A small crowd of people and behind the town hall,',

    //page 10
    '“You‘ve earnt a drink Eanom and see the wounds are cleaned”,',
    'Sigg handed him a few coins to which he gratefully beamed,',
    '“Over there is the Greasy Duck, I‘ll be drunk if you need me”,',
    'Sigg nodded “I‘ve a few errands to run then I‘ll be free”,',
    'They shook hands like they‘d been friends for years,',
    'Sigg needed more details before he could stop for beers,',
    'He made his way along towards the hall of the small town,',
    'The door opened and there stood a woman wearing a red gown,',
    '“Greetings stranger, I‘m the Governess, tell me everything”,',
    'She carried authority, a ledger and wore a golden ring,',
    '“Greetings, I actually came through here many months back”,',
    'Sigg took off his helmet and dropped his heavy pack,',
    '“Oh WarScholar! I remember you. Locals still bless your name”,',
    '“As you did once I‘m hoping you can help us again”,',
    '“Yes but...“ Sigg started but she held up her hand,',
    '“Please, we have merchants coming to us from a distant land”,',
    '“I know you‘ll be able to ensure our village is safe for their stay”,',
    'Sigg‘s eyes met hers and he shook his head “Nay”,',
    '“I‘m sorry to inform you that spine-backs slew them all”,',
    '“I need to know where they would take their windfall”,',
    '“They have something of mine precious to my own kin”,',
    '“I must get it back, I need somewhere for my search to begin”,',

    //page 11
    'The Governess stood silent, thinking for a full minute,',
    '“If what you say is true we‘d all be dead if not for your visit”,',
    'The Governess pointed “Deep in the forest they are said to lurk”,',
    '“But you‘d need an army to do the killing work”,',
    '“Like locusts they migrate in large numbers once a generation”,',
    '“We were lucky a disease last time brought about their ruination”,',
    '“Our ancestors spoke of their kind in such terror”,',
    '“I now fear not taking them seriously was an error”,',
    '“I open the town coffers to you to rid us of this menace”,',
    '“I know without you the result will be horrendous”,',
    'Sigg knew this would be a long and tough task,',
    'And to better defend this village he had to ask,',
    '“How many guards can you spare to go on this quest?”,',
    '“I‘ll take just the veterans and will leave you the rest”,',
    '“We can spare none, we‘re already weak as it is”,',
    '“But the guard captain words we should take on this“‘,',
    '“All going to plan, they‘ll not your walls breach”,',
    '“But if we fail, we‘ve traded our last speech”,',
    '“May honour guide you WarScholar, may your blade cut true”,',
    '“I will inform everyone so that they will try to help you”,',
    'Sigg bowed and walked over to the Duck all Greasy,',
    'The mountain pass was supposed to be easy!',

    //page 12
    'The patrons all clapped for him as he walked in,',
    'Eanom had been talking and wore beer down his chin,',
    '“This is him! He cut the big one straight in half!”',
    'He tripped as he stood and others started to laugh,',
    '“No please, hold back your applause, many were lost this day”,',
    '“I wish more of them I saved, but listen to what I have to say”,',
    '“I need to go out there and retrieve something precious, now lost”,',
    'He scanned their faces, “I am willing to pay any cost!”,',
    'Most of them looked like they‘d be of little value in a fight,',
    'But there was one unusual man, that could be alright,',
    'He sat at a table, he was fixing something Sigg knew not what,',
    'He looked to be highly skilled in mending metal, bolt and nut,',
    '“Excuse me sir, are you willing to help me on my journey out?”',
    '“Sorry what? I haven‘t been listening to whatever this is about”,',
    'He put down his tools and looked for his drink,',
    'Sigg pleaded his case as the man began to think,',
    '“This hammer sounds like it would be worthy of study”,',
    '“But I fear with just two of us we‘d end up beaten and bloody”,',
    'Sigg nodded, “I‘ll bring along some of the town guard”,',
    '“To be honest with you it‘ll be dangerous and hard”,',
    '“Garson is my name, and don‘t worry I‘m well equipped”,',
    'He said with a smile and revealed the weapon he had gripped,',

    //page 13
    '“Is that some sort of axe? I‘ve not seen its like before”,',
    '“Its my own design, many foes now lay on the floor”,',
    'Sigg recruited throughout town for the rest of the day,',
    'In a small room in the tavern, the night he chose to stay,',
    'At morning‘s first light he was packed and ready to depart,',
    'Along with him, four guards, and Garson ready to make a start,',
    'Dane, Seb, Corl and Torgen were the only volunteers Sigg could get together,',
    'The guard Captain provisioned them with blades and armour of leather,',
    'They walked out the town gates and waved goodbye,',
    'Sigg left Eanom behind at the village to keep a watchful eye,',
    '“Good hunting WarScholar!” Eanom called from his guard position,',
    'Members of the village even came to wish them well on their mission,',
    '“So tell me more of this prized artefact, it must be rare indeed!”',
    'Garson, readied his notebook “Of its creation can I read?”,',
    '“It‘s one of the lost very powerful relics from my homeland”,',
    'Sigg looked down. “I feel foolish that I let it slip from my hand”,',
    '“Our people were protected and governed by the Founders long ago”,',
    '“But one betrayed the rest, for their power - a villainous foe”,',
    '“So the relics were scattered and at great length hidden deep”,',
    '“Many years have passed and now our enemies are coming back to reap”,',
    '“It‘s of utmost importance that I can defend my nation”,',
    '“I fear without it we would suffer no less than annihilation”,',

    //page 14
    '“Yes, yes, but tell me of its structure, it‘s substance what makes it so?”',
    '“I‘m a ThoughtShaper you see so I really want to know”,',
    'Sigg looked puzzled and tried to answer him in vain,',
    'He thought himself learned but he did not have that sort of brain,',
    'Garson nodded and made a few notes in one of his books,',
    'He was hoping this trip wouldn‘t disappoint him by his looks,',
    '“All of you have been paid half this morning and will yet receive more”,',
    '“Our plan is two-fold, the hammer and to keep those beasts from your door”,',
    'Dane spoke up, the youngest of the guards, “If nothing we find?”',
    '“Trust me, those beasts will find us never you mind”,',
    'They marched on through the countryside unabated,',
    'Slow but steady progress but still Sigg was frustrated,',
    'As afternoon came the farmlands and beaten path came to an end,',
    'All the guards drew their blades, upon which they would depend,',
    'The ancient trees rose high and did not bid them welcome,',
    'Entering beneath the canopy the fetid air made their lungs numb,',
    'A step in any direction felt like going up a steep slope,',
    'Garson grabbed a vial from his pocket, then appeared a strong rope,',
    '“Tie this fast about your waist, we can‘t become separated in here”,',
    'Sigg nodded, and replied “Single file, I‘ll lead, Corl take up the rear”,',
    'Garson wondered if his lungs were somehow being infected,',
    'They wandered through the timeless garden ever neglected,',


    //page 15
    'Near the point of exhaustion, they stopped in a small clearing,',
    'The broken canopy above somehow made the air worth breathing,',
    '“How much further?” Dane asked, speaking for all of them there,',
    'Sigg held up a finger, listening, and then pointed to his ear,',
    '“I thought I heard the sound of fighting in the distance”,',
    '“Anyone out this far will certainly need our assistance.”',
    'They all kept as quiet as they could, listened with all strain,',
    'Whatever Sigg heard was gone and was not to be heard again,',
    'Sigg wondered if he had really heard anything at all,',
    'Perhaps it was an echo from his past making a call,',
    'They sat and rested for a while, with nothing that would be a sign,',
    '“Let’s head further north,” Sigg couldn‘t help a tingle in his spine,',
    'Everyone did not jump at the chance to re-enter the trees,',
    'Receiving reluctant looks, “We can‘t stay,” to which all agrees,',
    'They strode into the forest‘s shadow once more,',
    'Immediately they felt the air tainted by unseen spore,',
    '“Hold up! I have a theory,” Garson spoke with a gleam in his eye,',
    'He trudged back to the clearing and looked up high,',
    'He shuffled in his pockets and mixed many a vial, ',
    'After a few moments he had a potion and a big smile,',
    '“This I think will do the trick to keep the air clean”,',
    '“Find me a few long branches and you’ll see what I mean”,',

    //page 16
    'Seb and Torgen made themselves useful and helped out,',
    'Garson continued to work but none could guess what it was about,',
    'Finally, he had crafted a long pole with a vial stuck to one end,',
    'Garson lifted it high and what happened next all had to commend,',
    'The vial gushed out a bright flame and burnt all the leaves close by,',
    'The canopy was pierced, and they could see a glimpse of the sky,',
    'With it the air was cleansed, Garson led the way on,',
    'It would now be easy to see which way they had gone,',
    'With happier lungs they made their way into the forest deep,',
    'Boldly venturing to where all manner of creatures roam and creep,',
    'Something was then heard making its way through the bracken,',
    '“Ready men!” Sigg was sure an animal was about to attack them,',
    'But a woman burst through, her eyes wide with fright,',
    'She couldn‘t help but stare up at Garson‘s chemical light,',
    '“Are you hurt?” Sigg lowered his weapon and began to say,',
    '“Spine-backs! A horde of them is heading this way!”',
    'She tied up her long black hair and drew a large knife,',
    'It was clear to Sigg, with that blade she had taken life,',
    '“Back to the clearing!” They turned and hurried back at a jog,',
    'They began to hear a multitude coming closer, half rat, half hog,',
    'Garson took down his vial and added an ingredient or two,',
    'He shook it, then with a heave through the trees it flew,',

    //page 17
    '“Run!” He cried as it detonated into a giant ball of flame,',
    'Trees, foliage and spine-backs roasted would never be the same,',
    'They used the break in the canopy to guide their way back,',
    'The roar behind them indicated numbers they did not lack,',
    'Corl burst out a scream as he fell bleeding from his shoulder,',
    'A spine-back stood with blade in hand still a-smoulder,',
    'Dane spun about and carved him a new breathing hole,',
    'He saw then they were set upon by an entire beast patrol,',
    '“Get up!” He commanded, giving Corl a hand to regain his footing,',
    'He encouraged him to hurry and where his boot he‘d be putting,',
    '“Just a bit further!” Sigg called out in a loud voice,',
    'Fighting them here would be hard, but they had no choice,',
    'But it was too late and a pack of them charged in,',
    'Blades clashed, blood spilled as one beast lost its chin,',
    'Dane hacked his way through the first few creatures in range,',
    'As he stepped into the forest shadow he could feel the change,',
    'His energy seemed drained, and his movements became slow,',
    'Corl reached out and drew him back before he suffered a killing blow,',
    '“I was hoping you‘d owe me for longer than that”,',
    'Corl smiled, swinging his blade “No time to chat!”,',
    'Sigg grabbed a small beast by the throat mid-leap,',
    'He stabbed him thoroughly then threw him down in a heap,',

    //page 18
    '“Cover me!” The woman cried, kneeling and placing her palms in the dirt,',
    'The rest of them circled around her to try and keep her unhurt,',
    'Garson‘s unique axe had a mechanism and spring-loaded cutting edge,',
    'Mid-strike, he pulled the trigger and splashed blood over the hedge,',
    'They worked together just managing to keep them at bay,',
    'More and more spine-backs clambered over where their dead lay,',
    'The woman drew her hands up and chanted words of power,',
    'Up through the ground shot spiked vines with red flower,',
    'The spine-backs were lifted off the ground and torn asunder,',
    'The rest of them couldn‘t help but be filled with wonder,',
    'They counter-charged the beasts and sent them reeling,',
    'Their foe‘s line broke and fled in all directions squealing,',
    'For a moment they stood panting hard to catch their breath,',
    'The vines slowly receded apparently had their fill of death,',
    '“I‘m Andell. Thank you for your help,” she looked utterly spent,',
    '“I knew those things had bred, but not to such a great extent!”,',
    '“Truly, you have an amazing gift, I‘d be keen to learn more”,',
    'Garson made a note in his book after wiping off the guts and gore,',
    '“You are very capable I can tell, but still it‘s dangerous here alone”,',
    'Sigg explained “we‘re going to stop these beasts in their home.”,',
    '“The brood-mother in the nest is dangerous beyond measure”,',
    '“The combined forces of us may yet be enough to stop her however”,',

    //page 19
    'Andell looked at each of them in turn, hoping to find,',
    'Some evidence of strength that would ease her mind,',
    '“They‘ve taken something vital from me I must regain”,',
    'Andell understood, “Put a stop to them and I‘d bless your name”,',
    '“Those disgusting things are the cause of all my miseries”,',
    'They stopped and Andell tended to their many injuries,',
    'So they followed Andell deeper into the forest of old,',
    'Garson crafted another fire to keep lungs clear of mould,',
    'They trudged on through the day and into the night,',
    'As light became scarce every new sound caused fright,',
    '“Steady on men, it is they who have you to fear!”,',
    'Sigg reassured them and hoped they were near,',
    'They climbed a small hill and stopped at its peak,',
    'Despite their best efforts everyone felt sore and weak,',
    'Sigg raised a hand “lets rest for a bit, setup a camp”,',
    'Andell pointed, “Down there is the nest amid the swamp”,',
    'Andell, Garson and the guards sat down on the fallen leaves.',
    '“We‘ll need every blade sharp, everything up your sleeves”,',
    '“But I know we can break them, this now I pledge”,',
    'Sigg patrolled and thought of what could give them an edge,',
    'Garson seemed to be lost in thought, he began to craft,',
    'Andell mixed some herbs and shared a fruity draught,',

    //page 20
    'They hadn‘t been still long when they heard more foes,',
    'Garson combined some elixirs and large yellow flame arose,',
    'It burnt through a swathe of branches above their heads,',
    'The light would help in battle and stave off their dread,',
    'Rustling behind the trees and darting shadows encircled,',
    'They readied their weapons as the flare sparkled,',
    'Sigg asked Garson “Will your flame last until daybreak?”',
    '“I don‘t think so, I should’ve packed more fuel, my mistake”,',
    '“Come get some!” Dane taunted as he gestured with his blade,',
    'But the pig-rats kept to the shadows and for the moment seemed afraid,',
    'Dane made a few steps out but at once felt drained,',
    '“We need to fight them on our terms,” Sigg explained,',
    'He returned and could do little but wait and watch,',
    'He‘d rather they attacked and he could them dispatch,',
    'Andell sat cross-legged and closed her eyes tight,',
    'It seemed like now this impasse would last all night,',
    'Eventually Garson‘s flame started to dim,',
    'Sigg walked over and stood next to him,',
    'The beasts advanced on all sides as the darkness closed in,',
    'It became clear at any moment the battle would begin,',
    'Sigg looked up and was able to partially see the moon,',
    'Day‘s light seemed an eternity away, but they needed it soon,',

    //page 21
    'With a screech and leap the bravest creature launched the attack,',
    'Seeing it move others followed suit and in rushed the pack,',
    '“Drive them back to the darkness! Give them no quarter!”',
    'Sigg‘s swung his sword and a creature became one head shorter,',
    'Andell opened her eyes and sprang to her feet blade in hand,',
    'Her expression showed she didn‘t have time for what she planned,',
    'The forest shook as the beasts scrambled between the trees,',
    'Dane finally could wet his blade and cut one off at the knees,',
    'A follow up stab and that foul thing met its end,',
    'Dane‘s back was covered by whom he could depend,',
    'Corl stabbed a foe but got his blade struck on withdraw, ',
    'A cry of pain escaped him as his flesh was torn by sharp claw,',
    'Torgen strode over and swung his battle mace,',
    'Two more beasts fell victim to Death‘s embrace,',
    'The flame above them spluttered, it‘s light dropped to a dim glow,',
    'In their prey‘s eyes the pig-rats size seemed to grow,',
    'Fending off multiple attacks Seb suffered a cut to his mid-section,',
    'He kept on fighting, but blood loss made pale his complexion,',
    'Andell nimbly darted between her targets spilling open their guts,',
    'But with all the claws flying about she earnt her share of cuts,',
    '“We can break them! Their numbers are running few”,',
    'Sigg punched one with a steel fist then hacked another in two,',

    //page 22
    'With a screech and leap the bravest creature launched the attack,',
    'Seeing it move others followed suit and in rushed the pack,',
    '“Drive them back to the darkness! Give them no quarter!”',
    'Sigg‘s swung his sword and a creature became one head shorter,',
    'Andell opened her eyes and sprang to her feet blade in hand,',
    'Her expression showed she didn‘t have time for what she planned,',
    'The forest shook as the beasts scrambled between the trees,',
    'Dane finally could wet his blade and cut one off at the knees,',
    'A follow up stab and that foul thing met its end,',
    'Dane‘s back was covered by whom he could depend,',
    'Corl stabbed a foe but got his blade struck on withdraw, ',
    'A cry of pain escaped him as his flesh was torn by sharp claw,',
    'Torgen strode over and swung his battle mace,',
    'Two more beasts fell victim to Death‘s embrace,',
    'The flame above them spluttered, it‘s light dropped to a dim glow,',
    'In their prey‘s eyes the pig-rats size seemed to grow,',
    'Fending off multiple attacks Seb suffered a cut to his mid-section,',
    'He kept on fighting, but blood loss made pale his complexion,',
    'Andell nimbly darted between her targets spilling open their guts,',
    'But with all the claws flying about she earnt her share of cuts,',
    '“We can break them! Their numbers are running few”,',
    'Sigg punched one with a steel fist then hacked another in two,',

    //page 23
    'Dane wiped the blood off his sword on to a large leaf,',
    '“If it‘s the last thing I do I‘ll pay back this deep grief”,',
    'They followed Andell until there was a break in the tall trees,',
    'They had reached the swamp with mud up to their knees,',


];